import { FunctionComponent } from "react";
import { FieldProps } from "@animech/axiom-ui-builder";
import * as Styled from "./accordion.style";
import { Root } from "@definitions";
import { ToggleClose, ToggleOpen } from "src/ui/components/icons";

export type ExtendedAccordionFieldProps = {
	id: string;
};

export type AccordionProps = FieldProps<Root> & ExtendedAccordionFieldProps;

export const Accordion: FunctionComponent<AccordionProps> = ({
	value,
	onValueChange,
	fieldMeta,
	id,
	children,
}) => {
	const isOpen = id === value;
	return (
		<Styled.AccordionRoot open={isOpen}>
			<Styled.Toggle
				onClick={() => {
					onValueChange!(isOpen ? undefined : id);
				}}
			>
				<Styled.Label>{fieldMeta?.label}</Styled.Label>
				{isOpen ? <ToggleClose /> : <ToggleOpen />}
			</Styled.Toggle>
			{isOpen && (
				<Styled.Panel>
					<Styled.Content>{children}</Styled.Content>
				</Styled.Panel>
			)}
		</Styled.AccordionRoot>
	);
};
